import { render, staticRenderFns } from "./side-tabs.vue?vue&type=template&id=142c9c18&scoped=true&"
import script from "./side-tabs.vue?vue&type=script&lang=js&"
export * from "./side-tabs.vue?vue&type=script&lang=js&"
import style0 from "./side-tabs.vue?vue&type=style&index=0&id=142c9c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c9c18",
  null
  
)

export default component.exports